<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <element-loading :active="loadingIn">
        <img src="img/loading_latino.gif" width="75px" height="75px" />
      </element-loading>
      <CRow class="justify-content-center">
        <CCol md="12">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm id="formPer" @submit.prevent="enviar">
                <CRow>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Nombre<span class="text-danger">*</span>
                      </label>
                      <CInput
                        placeholder="Nombre"
                        autocomplete="Nombre"
                        v-model="personas.nombre"
                        required
                      >
                        <!--   <template #prepend-content
                          ><CIcon name="cil-user"
                        /></template> -->
                      </CInput>
                    </div>
                  </CCol>

                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Apellido Paterno<span class="text-danger">*</span>
                      </label>
                      <CInput
                        placeholder="Apellido Paterno"
                        autocomplete="Apellido Paterno"
                        v-model="personas.apellidoP"
                        required
                      >
                        <!--   <template #prepend-content
                          ><CIcon name="cil-user"
                        /></template> -->
                      </CInput>
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Apellido Materno<span class="text-danger">*</span>
                      </label>
                      <CInput
                        placeholder="Apellido Materno"
                        autocomplete="Apellido Materno"
                        v-model="personas.apellidoM"
                        required
                      >
                        <!--   <template #prepend-content
                          ><CIcon name="cil-user"
                        /></template> -->
                      </CInput>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="4">
                    <div class="form-group mb-0">
                      <label for=""
                        >Fecha de nacimiento <span class="text-danger">*</span>
                      </label>
                      <div class="d-flex align-items-start">
                        <CInput
                          id="cDia"
                          type="number"
                          style="width: 100px"
                          placeholder="DD"
                          min="01"
                          max="31"
                          v-model="personas.dd"
                          required
                        />
                        <div
                          class="text-dark pl-1 pr-1"
                          style="font-size: 20px"
                        >
                          /
                        </div>
                        <CInput
                          id="cMes"
                          type="number"
                          style="width: 100px"
                          placeholder="MM"
                          min="01"
                          max="12"
                          v-model="personas.mm"
                          required
                        />

                        <div
                          class="text-dark pl-1 pr-1"
                          style="font-size: 20px"
                        >
                          /
                        </div>
                        <CInput
                          id="cAno"
                          type="number"
                          style="width: 150px"
                          placeholder="AAAA"
                          min="1900"
                          max="2500"
                          v-model="personas.aa"
                          required
                        />
                      </div>
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Correo electrónico <span class="text-danger">*</span>
                      </label>
                      <CInput
                        placeholder="Correo Electronico"
                        autocomplete="email"
                        v-model="personas.email"
                        required
                        type="email"
                      >
                        <!--  <template #prepend-content
                          ><CIcon name="cil-paper-at"
                        /></template> -->
                      </CInput>
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Número de teléfono <span class="text-danger">*</span>
                      </label>
                      <CInput
                        placeholder="Numero de Telefono"
                        autocomplete="Telefono"
                        @input="acceptNumber()"
                        v-model="personas.telefono"
                        required
                      >
                        <!--  <template #prepend-content
                          ><CIcon name="cil-user"
                        /></template> -->
                      </CInput>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Estado <span class="text-danger">*</span>
                      </label>
                      <CSelect
                        vertical
                        id="cbxEstado"
                        :options="catEstados"
                        placeholder="Estado"
                        required
                        v-model="personas.estado"
                        :value.sync="personas.estado"
                      >
                        <!-- <template #prepend-content
                          ><CIcon name="cil-location-pin"
                        /></template> -->
                      </CSelect>
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Seguro de interés <span class="text-danger">*</span>
                      </label>
                      <CSelect
                        vertical
                        :options="catProductos"
                        placeholder="Seguro de tu interes.."
                        required
                        v-model="personas.producto"
                        :value.sync="personas.producto"
                      >
                        <!--  <template #prepend-content
                          ><CIcon name="cil-list"
                        /></template> -->
                      </CSelect>
                    </div>
                  </CCol>
                </CRow>

                <CRow align-horizontal="center">
                  <CAlert
                    :color="alertColor"
                    closeButton
                    :show.sync="alertTrue"
                  >
                    {{ messageAlert }}
                  </CAlert>
                  <vue-recaptcha
                    sitekey="6Le6KAwcAAAAAHxMleQ5SVIUZ0jLIU2yzhahk8zM"
                  ></vue-recaptcha>
                </CRow>
                <CRow align-horizontal="center">
                  <div class="form-group pt-3 pb-3">
                    <CButton
                      class="pt-2 pb-2 pl-5 pr-5"
                      color="primary--custom"
                      shape="pill"
                      type="submit"
                      >Enviar</CButton
                    >

                    <!--<CButton
                        class="pt-2 pb-2 pl-5 pr-5"
                        color="primary--custom"
                        shape="pill"
                        @click="Limpia()"
                        >LIMPIAR</CButton>-->
                  </div>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import VueRecaptcha from "../../../node_modules/vue-recaptcha";

export default {
  components: {
    VueRecaptcha,
  },
  name: "LeadPer",
  data() {
    return {
      catEstados: [],
      catProductos: [],
      catProductosEmp: [],
      alertColor: "",
      messageAlert: "",
      alertTrue: false,
      tipo: "",
      personas: {
        nombre: "",
        apellidoP: "",
        apellidoM: "",
        email: "",
        telefono: "",
        producto: 0,
        estado: 0,
        fnacimiento: "",
        dd: "",
        mm: "",
        aa: "",
      },
      bValida: 0,
      flag: false,
      loadingIn: false,
      respuesta: [],
    };
  },
  methods: {
    register() {
      this.$router.push({ path: "/dashboard" });
    },

    enviar: function () {
      var payloadLead = {
        metodo: "SRVLEADS",
        data: {
          Nombre: this.personas.nombre,
          APaterno: this.personas.apellidoP,
          AMaterno: this.personas.apellidoM,
          Telefono: this.personas.telefono,
          email: this.personas.email,
          idCatTipoPersona: "1",
          idFormulario: "1",
          claveEstado: this.personas.estado,
          NombreEstado: $('select[id="cbxEstado"] option:selected').text(),
          NombreEmpresa: "",
          idCatProducto: this.personas.producto,
          FechaNacimiento:
            this.personas.dd + "/" + this.personas.mm + "/" + this.personas.aa,
        },
      };

      // console.log(payloadLead);
      this.loadingIn = true;
      this.$store.dispatch("metodoPost", payloadLead).then(() => {
        this.flag = this.$store.getters.getRespuestaFlagREST;
        console.log(this.flag);
        if (this.flag) {
          this.messageAlert =
            "Recibimos su solicitud, en breve uno de nuestros agentes se pondra en contacto con usted !!";
          this.alertColor = "success";
        } else {
          this.alertColor = "danger";
          this.messageAlert = "Algo salio mal, por favor intente mas tarde!!";
        }

        this.loadingIn = false;
        this.alertTrue = true;
      });
    },
    acceptNumber() {
      var x = this.value
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.value = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    Limpia() {
      var config = {
        metodo: "GETEMPLEADO",
        data: "IdEmpleado=650",
      };

      this.$store.dispatch("metodoPost", config).then(() => {
        this.respuesta = this.$store.getters.getRespuestaREST;
      });

      console.log(this.respuesta);
    },
  },
  mounted() {
    this.catEstados = [
      { value: "01", label: "Aguascalientes" },
      { value: "02", label: "Baja California" },
      { value: "03", label: "Baja California Sur" },
      { value: "04", label: "Campeche" },
      { value: "07", label: "Chiapas" },
      { value: "08", label: "Chihuahua" },
      { value: "09", label: "CDMX" },
      { value: "05", label: "Coahuila" },
      { value: "06", label: "Colima" },
      { value: "10", label: "Durango" },
      { value: "15", label: "Estado de México" },
      { value: "11", label: "Guanajuato" },
      { value: "12", label: "Guerrero" },
      { value: "13", label: "Hidalgo" },
      { value: "14", label: "Jalisco" },
      { value: "16", label: "Michoacán" },
      { value: "17", label: "Morelos" },
      { value: "18", label: "Nayarit" },
      { value: "19", label: "Nuevo León" },
      { value: "20", label: "Oaxaca" },
      { value: "21", label: "Puebla" },
      { value: "22", label: "Querétaro" },
      { value: "23", label: "Quintana Roo" },
      { value: "24", label: "San Luis Potosí" },
      { value: "25", label: "Sinaloa" },
      { value: "26", label: "Sonora" },
      { value: "27", label: "Tabasco" },
      { value: "28", label: "Tamaulipas" },
      { value: "29", label: "Tlaxcala" },
      { value: "30", label: "Veracruz" },
      { value: "31", label: "Yucatan" },
      { value: "32", label: "Zacatecas" },
    ];
    this.catProductos = [
      { value: 98, label: "Seguro de Accidentes" },
      { value: 99, label: "Seguro de Gastos Médicos Mayores" },
      { value: 100, label: "Seguro de Vida" },
      { value: 101, label: "Seguro de Auto o Pickup" },
      { value: 102, label: "Seguro de Auto Clásico" },
      { value: 103, label: "Seguro de Camión" },
      { value: 104, label: "Seguro de Motocicleta" },
      { value: 105, label: "Seguro de Daños Hogar" },
    ];

    this.catProductosEmp = [
      { value: 98, label: "Seguro de Accidentes" },
      { value: 99, label: "Seguro de Gastos Médicos Mayores" },
      { value: 100, label: "Seguro de Vida" },
      { value: 107, label: "Seguro de Flotilla" },
      { value: 106, label: "Seguro de Empresa" },
    ];
  },
};
</script>
